<app-app-loader *ngIf="showLoader"
                [diameter]="70"
                [strokeWidth]="6"></app-app-loader>
<router-outlet></router-outlet>